// extracted by mini-css-extract-plugin
module.exports = {"legal":"az_igb","headline":"az_jgb"};